<template>
  <oauth-wrapper
    :credentials.sync="credentials"
    :authorizeUrl="authorize_url"
    :tokenUrl="token_url"
    :logoutUrl="logout_url"
    :scope="scope"
    :client_id="client_id"
    :redirect_uri="redirect_uri"
    :loginIncrementor="loginIncrementor"
    :autologin="autologin"
    :debug="debug"
  >
    <div>
      <!-- <v-app-bar>Person settings</v-app-bar> -->
      <page-layout-side-nav
        :version="version"
        :user="limsds_userDetails"
        :isShowMainMenuLink="false"
        :navItems="navigationItems"
      >
        <transition name="slide-right" mode="out-in">
          <router-view></router-view>
        </transition>
      </page-layout-side-nav>
      <!-- <v-chip small label color="green darken-1">v<b>{{version}}</b></v-chip> -->
    </div>
  </oauth-wrapper>
</template>

<script>
//import appConfig from "./app.config"
import appMixin from "./mixins/app-mixin";
import appSettingsMixin from "@/_mixins/app-settings-mixin";
import pageLayoutSideNav from "@/_components/page-layouts/page-layout-side-nav";
import appAuthMixin from "./mixins/app-oauth-mixin";
import axios from "axios";
export default {
  name: "Application",
  created() {
    //this.applicationSettings = appConfig;
    // this.getUserId();
  },
  mixins: [appMixin, appSettingsMixin, appAuthMixin],
  components: { pageLayoutSideNav },
  computed: {
    version() {
      return this.settings.version;
    },
    navigationItems() {
      return this.settings.navigation.filter(
        (x) =>
          !x.roles ||
          x.roles.length === 0 ||
          (this.dummyUser.roles &&
            x.roles.filter((y) => this.dummyUser.roles.includes(y)).length > 0)
      );
    },
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal) {
        let userDetails = {
          //userName: `${this.credentials["jwt-decode"].given_name} ${this.credentials["jwt-decode"].family_name}`,
          userName: `${this.credentials["jwt-decode"].name}`,
          userEmail: `${this.credentials["jwt-decode"].upn}`,
        };
        this.limsds_userDetails = userDetails;
        if (this.limsds_userDetails.userEmail != null) {
          this.UserPreference();
        }
      }
    },
  },
  data: () => ({
    dummyUser: {
      userName: "Test User",
      roles: ["submitter"],
      //roles: []
    },
  }),
  methods: {
    getUserId() {
      let that = this;

      const loginUser = that.settings.WAUserId;
      axios.get(loginUser).then((response) => {
        that.limsds_userId = response.data.userId;
        if (that.limsds_userId != null) {
          that.UserPreference();
        }
      });
    },
    manageNewUSer() {
      let that = this;
      this.getUserByEmail();
      const userPref =
        this.settings.WAMUPreference +
        "logon=LYONDELL\\" +
        this.limsds_userId.userId  +
        "&unique_name=" +
        this.limsds_userId.userEmail +
        "&name=" +
        this.limsds_userId.userName +
        '&selected_site=BEO&areas=<root site="BEO"></root>&dateformat=dd/MM/yyyy&rowsinresulttable=2&showtestintable=2&limsinternal=0&completedonly=0&samplesback=3&componentorder=0&selected_unit=BDEUP&selected_area=BEO_DIB&showlabareaintable=2';
       axios.get(userPref).then((response) => {
        that.limsds_userPreference = response.data.value[0];
      });
    },
    getUserByEmail() {
      let that = this;
      const userByEmail =
        this.settings.WAUserByEmail +
        "emailId=" +
        this.limsds_userDetails.userEmail;
        axios.get(userByEmail).then((response) => {
        that.limsds_userId = response.data;
      });
    },
    UserPreference() {
      let that = this;
      //this.limsds_userDetails.userEmail='James.Epperson@lyondellbasell.com';
      const link =
        this.settings.WAPreferenceByUser +
        "UserID=" +
        this.limsds_userDetails.userEmail;
      axios
        .get(link)
        .then((response) => {
          that.limsds_userPreference = response.data.value[0];
          if (
            that.limsds_userPreference.PrefKey == 0 ||
            that.limsds_userPreference.PrefKey == null
          ) {
            that.manageNewUSer();
          }
        })
        .catch((error) => {
          this.$root.$refs.UIError.UserPreference(
            "Preference",
            "method",
            error
          );
        });
    },
    init() {
      console.log(this.credentials);
    },
  },
};
</script>

<style lang="scss">
</style>
